module.exports = __webpack_public_path__ + "static/arya-2ec01430592b327b22eb0ea399e088da.jpeg";